<template>
  <div class="error-prone-report">
    <div class="main">
      <div class="top">
        <div class="top-select">
          <el-select popper-class="select-down" v-model="subject" @change="changeSubject">
            <el-option
              :label="item.name"
              :value="item.code"
              v-for="item in subjects"
              :key="item.code" />
          </el-select>
          <el-select class="left-classify" popper-class="select-down"
            v-model="classify" @change="changeClassify">
            <el-option
              :label="item.name"
              :value="item.code"
              v-for="item in classifyList"
              :key="item.code" />
          </el-select>
        </div>
        <div class="tip">
          <div class="card">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/2af2910482ed974e75a42236030173b4.png" />
            <span>汇总了您近期知识点的学习以及考试记录等内容。</span>
          </div>
          <img class="close" @click="close" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png" alt="" />
        </div>
      </div>
      <div class="bottom">
        <div class="test-result">
          <div class="title">
            <span class="vertical-line"></span>
            <span>试卷报告</span>
          </div>
          <el-date-picker
            class="date"
            v-model="date"
            type="date"
            @change="changeDate"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div v-if="testPapers.length" class="fallibilitys">
          <div class="card fallibility" v-for="item in testPapers" :key="item.created_at">
            <h2>{{item.test_name}}</h2>
            <p class="subject">{{item.project_name}}</p>
            <p class="fraction"><span>{{item.scores}}</span>分</p>
            <p class="time">测试耗时：{{item.spend_time}}</p>
            <p class="time">测试时间：{{item.created_at}}</p>
            <span class="certificate" @click="showReport(item)">查看详情</span>
          </div>
        </div>
        <div v-else class="no-data">暂无数据</div>
        <van-page class="page" :total="total" :page-size="pageSize" @changePage="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Select, Option, Input, Pagination, Button, DatePicker } from 'element-ui';
import report from '@/api/report';
import VanPage from '../personal/Page.vue';

export default {
  components: {
    VanPage,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElPagination: Pagination,
    ElButton: Button,
    ElDatePicker: DatePicker,
  },
  data() {
    return {
      subject: '',
      classify: '',
      date: '',
      overview: {},
      subjects: [],
      classifyList: [],
      total: 0,
      pageSize: 8,
      page: 1,
      testPapers: [],
    };
  },
  created() {
    this.cache = JSON.parse(sessionStorage.getItem('fallibleReport')) || {};
    this.getTestStatisticReportTypes();
  },
  methods: {
    changeSubject() {
      this.page = 1;
      this.getClassifyList();
    },
    changeClassify() {
      this.page = 1;
      this.getTestStatisticReports();
    },
    changeDate() {
      this.page = 1;
      this.getTestStatisticReports();
    },
    close() {
      this.$emit('close');
    },
    showReport(details) {
      const { test_id, overview_id } = details;
      if (this.classify === 'English' || this.classify === 'Chinese' || this.classify === 'Chemistry') {
        this.$emit('change', {
          scene: 'quizzesDialog',
          params: {
            type: 'fallibleReport',
            course: {
              projectCode: this.classify,
              type: {
                English: 'BKW',
                Chinese: 'YW',
              }[this.classify] || '',
            },
            testId: test_id,
            overviewId: overview_id,
            score: details.scores,
            isExamRecords: 1,
          },
        });
      } else {
        this.$emit('change', {
          scene: 'quizzesDialog',
          params: {
            type: 'fallibleReport',
            course: {
              projectCode: this.classify,
              type: '',
            },
            examId: test_id,
            overviewId: overview_id,
            score: details.scores,
            isExamRecords: 1,
          },
        });
      }
    },
    changePage(curPage) {
      this.page = curPage;
      this.getTestStatisticReports();
    },
    getTestStatisticReportTypes() {
      report.getTestStatisticReportTypes()
        .then((data) => {
          this.subject = this.cache.subject || data[0].code;
          this.subjects = data;
          this.getClassifyList();
        })
    },
    getClassifyList() {
      report.getSubjects({project_code: this.subject})
        .then((data) => {
          this.classify = this.cache.classify || data[0].code;
          this.classifyList = data;
          this.getTestStatisticReports();
        })
    },
    getTestStatisticReports() {
      report.getTestStatisticReports({
        type: this.subject,
        project_code: this.classify,
        now_page: this.page,
        per_page: this.pageSize,
        time: this.date,
      })
        .then((data) => {
          this.total = data.count;
          this.testPapers = data.data;
        })
    }
  },
  beforeDestroy() {
    const optios = {
      subject: this.subject,
      classify: this.classify || null,
    };
    sessionStorage.setItem('fallibleReport', JSON.stringify(optios));
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .error-prone-report {
    position: relative;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .main {
      margin: 2% auto 0;
      padding: 30px;
      box-sizing: border-box;
      width: 90%;
      height: 90%;
      background-color: #fff;
      border-radius: 24px;
      .card {
        border-radius: 18px;
        box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
      }
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        line-height: 6vh;
        font-size: 2vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
      }
      .top {
        display: flex;
        width: 100%;
        height: 8%;
        &-select {
          .left-classify {
            margin-left: 10%;
          }
          /deep/ .el-select {
            width: 40%;
            height: 100%;
            .is-focus {
              .el-input__inner {
                border-color: $primary;
              }
            }
            .el-input {
              height: 100%;
              .el-input__inner {
                &:focus {
                  border-color: $primary;
                }
                height: 100%;
                text-align: center;
                color: $primary;
                font-size: 2.5vh;
                font-weight: 700;
                border-radius: 20px;
                box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-select__caret {
                    font-size: 2vh;
                    font-weight: 700;
                    color: $primary;
                  }
                }
              }
            }
          }
        }
        .tip {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          div {
            padding: 0 2%;
            display: flex;
            align-items: center;
            width: 88%;
            height: 100%;
            img {
              height: 50%;
            }
            span {
              margin-left: 2%;
              font-size: 2.5vh;
              color: $primary;
            }
          }
          .close {
            cursor: pointer;
          }
        }
      }
      .bottom {
        .test-result {
          line-height: 8vh;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .date {
            width: 150px;
            /deep/ .el-input__inner {
              &:focus {
                border-color: $primary;
              }
              color: $primary;
              font-weight: 700;
              border-radius: 12px;
            }
            /deep/ .el-input__prefix {
              font-size: 2vh;
              color: $primary;
            }
          }
        }
        .fallibilitys {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          height: 64vh;
          .fallibility {
            margin-right: 2%;
            padding: 2vh;
            width: 20%;
            &:hover {
              color: #fff!important;
              background-color: #5A5FEF!important;
              h2 {
                color: #fff;
              }
              .certificate {
                color: #5A5FEF;
                background-color: #fff;
              }
              .subject {
                color: #fff;
              }
              .fraction {
                color: #fff;
              }
            }
            h2 {
              margin: 0;
              width: 60%;
              font-size: 2.5vh;
              color: #5A5FEF;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            p {
              margin: 0;
            }
            .subject {
              line-height: 4vh;
              font-size: 2vh;
              color: #5A5FEF;
            }
            .fraction {
              text-align: center;
              line-height: 7vh;
              color: #5A5FEF;
              font-size: 3vh;
              span {
                font-size: 6vh;
                font-weight: bold;
              }
            }
            .time {
              line-height: 4vh;
              font-size: 2vh;
            }
            .certificate {
              padding: 1vh 3vh;
              position: absolute;
              top: 0;
              right: 0;
              font-size: 1.5vh;
              color: #fff;
              cursor: pointer;
              border-top-right-radius: 18px;
              border-bottom-left-radius: 18px;
              background-color: #646DE2;
            }
          }
        }
        .no-data {
          margin-top: 10%;
          font-size: 3vh;
          color: #5A5FEF;
          text-align: center;
        }
        .page {
          margin-top: 2vh;
        }
      }
    }
  }
  .select-down {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .el-select-dropdown__item {
            font-size: 2vh;
          }
          .selected {
            color: $primary;
          }
        }
      }
    }
  }
</style>
